import { render, staticRenderFns } from "./CreateNewContract.vue?vue&type=template&id=1fbdca2b&scoped=true"
import script from "./CreateNewContract.vue?vue&type=script&lang=js"
export * from "./CreateNewContract.vue?vue&type=script&lang=js"
import style0 from "./CreateNewContract.vue?vue&type=style&index=0&id=1fbdca2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbdca2b",
  null
  
)

export default component.exports